function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.5907 10.6877L23.5904 10.6876L1.67573 1.5267C1.67564 1.52666 1.67555 1.52662 1.67546 1.52659C1.54892 1.47386 1.40366 1.50111 1.3053 1.59503C1.20674 1.68915 1.17334 1.83268 1.2201 1.96046L1.22036 1.96117L9.36551 24.274C9.41339 24.4052 9.53621 24.4949 9.67701 24.5C9.8167 24.5046 9.94528 24.4237 10.0017 24.2962L10.0019 24.2956L13.7258 15.8932L23.5907 10.6877ZM23.5907 10.6877C23.7202 10.7418 23.8027 10.8682 23.8009 11.0068L23.8009 11.0078C23.7992 11.1475 23.7129 11.2723 23.5824 11.3231L23.5823 11.3231L15.0174 14.6575L15.0146 14.6586M23.5907 10.6877L15.0146 14.6586M15.0146 14.6586C14.4416 14.8836 13.9772 15.3251 13.7261 15.8924L15.0146 14.6586Z",
  stroke: "#1F79FF",
  strokeWidth: 2
});

var SvgIconNearby = function SvgIconNearby(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconNearby, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-nearby.69661d60.svg";
export { ForwardRef as ReactComponent };